export function getKeyByValue({
  object,
  value,
}: {
  object: { [key: string]: string | number }
  value: number | string
}) {
  return Object.keys(object).find((key) => object[key] === value) || ''
}
